import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

export const DateField = ({ label, name, register, errors = {}, controlclass = '', setValue, value }) => {
  const isInvalid = !!errors?.[name];

  const handleChange = (date) => {
    setValue(name, date, { shouldValidate: true });
  };

  return (
    <Form.Group controlId={name} className={controlclass}>
      {label && <Form.Label>{label}</Form.Label>}
      <DatePicker
        selected={value ? new Date(value) : null}
        onChange={handleChange}
        dateFormat="dd/MM/yyyy"
        className={`form-control ${isInvalid ? 'is-invalid' : ''}`}
        placeholderText="dd/mm/yyyy"
      />
      {isInvalid && (
        <div className="invalid-feedback">{errors?.[name]?.message}</div>
      )}
    </Form.Group>
  );
};

DateField.propTypes = {
  label: PropTypes.node,
  name: PropTypes.string.isRequired,
  register: PropTypes.func,
  errors: PropTypes.object,
  setValue: PropTypes.func.isRequired,
  value: PropTypes.any,
  controlclass: PropTypes.string,
};
